import RequireAuth from "@/components/hoc/RequireAuth";
import RootLayout from "@/components/layout/RootLayout";
import useInjectSidebar from "@/hooks/useInjectSidebar";
import StrategicPlanningViewer from "@/pages/strategic-planning/_id/StrategicPlanningViewer";
import StrategicPlanningViewerLayout from "@/pages/strategic-planning/_id/StrategicPlanningViewerLayout";

const AppLayout = () => {
    const root = useInjectSidebar({ sidebarName: "workspace" })(RootLayout);
    return <RequireAuth>{root}</RequireAuth>;
};

export const strategicPlanningRoute = {
    path: "/strategic-plannings",
    element: <AppLayout />,
    children: [
        {
            path: ":strategicPlanningId",
            element: <StrategicPlanningViewerLayout />,
            children: [
                {
                    index: true,
                    element: <StrategicPlanningViewer />,
                },
            ],
        },
        {
            path: "new",
            element: <div>comming soon</div>,
        },
    ],
};
